import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { base44 } from '@/api/base44Client';

export function useSchedulePresenceConfirmation({ entityName, queryKey, setViewingSchedule }) {
  const queryClient = useQueryClient();
  const scheduleQueryKey = [queryKey];

  return useMutation({
    mutationFn: ({ id, members }) => base44.entities[entityName].update(id, { members }),
    onMutate: async ({ id, members }) => {
      await queryClient.cancelQueries({ queryKey: scheduleQueryKey });
      const previousSchedules = queryClient.getQueryData(scheduleQueryKey);
      const previousSchedule = previousSchedules?.find((schedule) => schedule.id === id);
      queryClient.setQueryData(scheduleQueryKey, (current) => current?.map((schedule) =>
        schedule.id === id ? { ...schedule, members } : schedule
      ));
      setViewingSchedule((current) => current?.id === id ? { ...current, members } : current);
      return { previousSchedules, previousSchedule };
    },
    onSuccess: () => toast.success('Presença confirmada.'),
    onError: (error, { id }, context) => {
      if (context?.previousSchedules) queryClient.setQueryData(scheduleQueryKey, context.previousSchedules);
      if (context?.previousSchedule) {
        setViewingSchedule((current) => current?.id === id ? context.previousSchedule : current);
      }
      toast.error(error?.message || 'Não foi possível confirmar a presença. Tente novamente.');
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: scheduleQueryKey }),
  });
}
